import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { WebAPIService } from 'src/app/services/webapi/web-api.service';
import { WebAPIConstants } from 'src/app/services/globalConstants/global-constants.service';
import { DeviceInfoService } from 'src/app/services/deviceInfo/device-info.service';

import { ICarritoWeb } from 'src/app/interfaces/ICarritoWeb';
import { Observable } from 'rxjs';
import { ICarritoProductoWeb } from 'src/app/interfaces/ICarritoProductoWeb';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class CarritoService {

  //#region Propiedades

  public CurrentCarrito: Array<ICarritoWeb> = [];

  public IncrementoValido: number;
  public DecrementoValido: number;
  public EliminacionValida: number;

  public VaciarCarrito: number;

  public ProductsCart: number = -1;

  //#endregion

  //#region Constructor

  constructor(private _webAPISrv: WebAPIService,
              private _deviceInfoSrv: DeviceInfoService,
              private _storageSrv: StorageService) { }

  //#endregion

  public getCarritoWeb() {
    const url: string = WebAPIConstants.URLCarrito + 'getCarrito/';
    const deviceUUID: string = this._deviceInfoSrv.CurrentDeviceInfo.DeviceUUID;
    console.log('toda la info device');
    console.log(this._deviceInfoSrv.CurrentDeviceInfo);
    const token: string = this._deviceInfoSrv.CurrentDeviceInfo.Token;
    return this._webAPISrv.get(url, deviceUUID, token, true).pipe(map((Item: Array<ICarritoWeb>) => {
      this.CurrentCarrito = Item;
      console.log('-------------------------------------------');
      console.log('CarritoService >> getCarrito >> ' + Item.length);
      console.log('-------------------------------------------');
    }));
  }

  public agregarProducto(idSucursal: string, producto: any, idCarrito: number): Observable<any> {

    const idUsuarioWeb: number = this._storageSrv.getIdUsuario();

    // construye estructura para registar un carro de compras
    const newCarrito: ICarritoWeb = {
      IdCarrito: idCarrito,
      IdSucursal: idSucursal,
      IdTipoPedido: 2,
      IdStatus: 1,
      IdTamano: producto.IdTamano,
      Precio: producto.PrecioPublico,
      DeviceInfo: this._deviceInfoSrv.CurrentDeviceInfo,
      Producto: producto,
      IdUsuarioWeb: idUsuarioWeb
    };

    // guarda producto/carrito en API
    const url: string = WebAPIConstants.URLCarrito + 'agregarProducto';
    return this._webAPISrv.post(url, newCarrito, '', false).pipe(map((idCart: number) => {
      console.log('-------------------------------------------');
      console.log('CarritoService >> agregarProducto >> ' + idCart);
      console.log('-------------------------------------------');
    }));

  }

  public aumentarCantidadProducto(
    idSucursal: string, idProductoWeb: number, codigoProductoWeb: string, cantidad: number, idProductoCarrito: number): Observable<any> {

    // traer disponibilidad de producto
    const url: string = WebAPIConstants.URLCarrito + 'aumentarCantidadProducto/' +
      idSucursal + '/' + idProductoWeb + '/' + codigoProductoWeb + '/' + cantidad + '/' + idProductoCarrito;
    const deviceUUID: string = this._deviceInfoSrv.CurrentDeviceInfo.DeviceUUID;
    const token: string = this._deviceInfoSrv.CurrentDeviceInfo.Token;

    return this._webAPISrv.get(url, deviceUUID, token, true).pipe(map((existencia) => {
      this.IncrementoValido = existencia;

      console.log('-------------------------------------------');
      console.log('CarritoService >> aumentarCantidadProducto >> ' + this.IncrementoValido);
      console.log('-------------------------------------------');

    }));

  }

  public disminuirCantidadProducto(
    cantidad: number, idProductoCarrito: number): Observable<any> {

    // traer disponibilidad de producto
    const url: string = WebAPIConstants.URLCarrito + 'disminuirCantidadProducto/' + cantidad + '/' + idProductoCarrito;
    const deviceUUID: string = this._deviceInfoSrv.CurrentDeviceInfo.DeviceUUID;
    const token: string = this._deviceInfoSrv.CurrentDeviceInfo.Token;

    return this._webAPISrv.get(url, deviceUUID, token, true).pipe(map((existencia) => {
      this.DecrementoValido = existencia;

      console.log('-------------------------------------------');
      console.log('CarritoService >> disminuirCantidadProducto >> ' + this.DecrementoValido);
      console.log('-------------------------------------------');

    }));

  }

  public eliminarProducto(
    idProductoCarrito: number): Observable<any> {

    // traer disponibilidad de producto
    const url: string = WebAPIConstants.URLCarrito + 'eliminarProducto/' + idProductoCarrito;
    const deviceUUID: string = this._deviceInfoSrv.CurrentDeviceInfo.DeviceUUID;
    const token: string = this._deviceInfoSrv.CurrentDeviceInfo.Token;

    return this._webAPISrv.get(url, deviceUUID, token, true).pipe(map((eliminado) => {
      this.EliminacionValida = eliminado;

      console.log('-------------------------------------------');
      console.log('CarritoService >> eliminarProducto >> ' + this.EliminacionValida);
      console.log('-------------------------------------------');

    }));

  }

  public vaciarCarrito(
    idCarrito: number): Observable<any> {
    // traer disponibilidad de producto
    const url: string = WebAPIConstants.URLCarrito + 'vaciarCarrito/' + idCarrito;
    const deviceUUID: string = this._deviceInfoSrv.CurrentDeviceInfo.DeviceUUID;
    const token: string = this._deviceInfoSrv.CurrentDeviceInfo.Token;

    return this._webAPISrv.get(url, deviceUUID, token, true).pipe(map((eliminado) => {
      this.VaciarCarrito = eliminado;

      console.log('-------------------------------------------');
      console.log('CarritoService >> vaciarCarrito >> ' + this.VaciarCarrito);
      console.log('-------------------------------------------');

    }));

  }

  public editarMensajeProducto(idProductoCarrito, mensaje): Observable<any> {

    // construye estructura para actualizar el mensaje
    const newMensaje: ICarritoProductoWeb = {
      IdCarritoProducto: idProductoCarrito,
      DeviceInfo: this._deviceInfoSrv.CurrentDeviceInfo,
      MensajeTarjeta: mensaje,
    };

    // guarda visita en API
    const url: string = WebAPIConstants.URLCarrito + 'editarMensaje';
    return this._webAPISrv.post(url, newMensaje, '', false).pipe(map((idCart: number) => {
      console.log('-------------------------------------------');
      console.log('CarritoService >> editarMensajeProducto >> ' + idCart);
      console.log('-------------------------------------------');
    }));

  }

  public async validaProductosCart() {
    console.log('entre aqui y el valor actual es', this.ProductsCart);
    if (this.ProductsCart == -1) { // Contar si hay elementos en el carrito
      this.getCarritoWeb().subscribe(() => {
        const _listProduct = this.CurrentCarrito['Productos'];
        const tagNumber = document.getElementById('numberProd');
        console.log('asignar: ', _listProduct.length);
        this.ProductsCart = _listProduct.length;
        tagNumber.innerHTML = this.ProductsCart.toString();
      });
    }
    else {
      console.log('entre aqui ya habia valor');
      const tagNumber = document.getElementById('numberProd');
      tagNumber.innerHTML = this.ProductsCart.toString();
    }

  }
}
